import React from "react";
import PropTypes from "prop-types";

const VARIANT_CLASS = {
  active: "status-badge--active",
  inactive: "status-badge--inactive",
  pending: "status-badge--pending",
  approved: "status-badge--approved",
  revision: "status-badge--revision",
  rejected: "status-badge--rejected",
  draft: "status-badge--pending",
  delayed: "status-badge--delayed",
  delay: "status-badge--delayed",
  sent_to_rtm: "status-badge--revision",
  returned_to_supervisor: "status-badge--revision",
  level_one_approved: "status-badge--approved",
  level_one_rejected: "status-badge--rejected",
  auto_approved: "status-badge--approved",
  auto_rejected: "status-badge--rejected",
  auto_sent_rtm: "status-badge--revision",
  signed_off: "status-badge--approved",
  completed: "status-badge--approved",
  rejected: "status-badge--rejected",
  deleted: "status-badge--inactive",
};

const normalizeKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/^sent_rtm$/, "sent_to_rtm");

export const resolveStatusBadgeVariant = (value, isActiveFlag) => {
  if (isActiveFlag === "y" || isActiveFlag === true) return "active";
  if (isActiveFlag === "n" || isActiveFlag === false) return "inactive";

  const key = normalizeKey(value);
  if (key === "delay") return "delayed";
  return VARIANT_CLASS[key] ? key : "pending";
};

const StatusBadge = ({ label, variant, className = "" }) => {
  const resolvedVariant = VARIANT_CLASS[variant] ? variant : "pending";
  const displayLabel =
    label ||
    String(variant || "pending")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <span
      className={`status-badge ${VARIANT_CLASS[resolvedVariant]} ${className}`.trim()}
    >
      {displayLabel}
    </span>
  );
};

StatusBadge.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.string,
  className: PropTypes.string,
};

export default StatusBadge;
